import { render } from "./Appcourserecord.vue?vue&type=template&id=4197854b&scoped=true"
import script from "./Appcourserecord.vue?vue&type=script&lang=js"
export * from "./Appcourserecord.vue?vue&type=script&lang=js"

import "./Appcourserecord.vue?vue&type=style&index=0&id=4197854b&lang=less&scoped=true"

import exportComponent from "../../../node_modules/.store/vue-loader@17.1.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4197854b"]])

export default __exports__